import { defineStore } from "pinia";
import { ref } from "vue";
import { withLoading } from "@erp/shared/utils/loading/with-loading";
import { searchCardInputs } from "../Search/const";
import { searchObtainWithReject, } from "@erp/shared/api/generated/wrappers/obtain";
/**
 * @description 수주현황 검색 Input 항목을 관리하는 Store
 *
 * @param {InputItem[]} searchInputs - 검색 Input 항목 목록 (승인, 프로젝트코드...)
 *
 * @param {Function} setByLabel - 특정 label에 해당하는 Input 항목의 값을 설정하는 함수
 * @param {Function} setSearchCardInputs - 여러 Input 항목의 값을 한 번에 설정하는 함수 => 변경 있으면 1, 없으면 0 반환
 *
 * @param {Function} search - 현재 설정된 Input 항목을 기반으로 수주 및 설계 데이터를 검색하는 함수
 */
export const useObtainSearch = defineStore("obtain-useObtainSearchInput", () => {
    const searchInputs = ref(searchCardInputs);
    const searchRes = ref([]);
    const setByLabel = (label, value) => {
        const input = searchInputs.value.find((x) => x.label === label);
        if (!input) {
            console.warn(`label "${label}" 항목을 찾을 수 없습니다.`);
            return;
        }
        input.value = value;
    };
    const setSearchCardInputs = (projectCode, inhouseBidNumber, companyBidNumber, companyName, issueDate) => {
        if (!searchInputs.value || searchInputs.value.length <= 0)
            return 0;
        if (searchInputs.value[0].value === "All") {
            searchInputs.value[0].value = "";
        }
        setByLabel("프로젝트 코드", projectCode);
        setByLabel("사내 견적번호", inhouseBidNumber);
        setByLabel("기업별 입찰번호", companyBidNumber);
        setByLabel("업체명", companyName);
        const dateValue = issueDate.includes(" ~ ")
            ? issueDate.split(" ~ ")
            : [issueDate, issueDate];
        setByLabel("발행일", dateValue);
        return 1;
    };
    const search = async () => {
        if (searchInputs.value[0].value === "All") {
            searchInputs.value[0].value = "";
        }
        withLoading(async () => {
            searchRes.value = await searchObtainWithReject(searchInputs.value);
        });
    };
    return {
        searchRes,
        searchInputs,
        setSearchCardInputs,
        search,
    };
});
